import React from 'react';
import styled from '@benzinga/themetron';

interface ErrorType {
  error: string[];
}

export const Error: React.FC<ErrorType> = ({ error }) => {
  return <ErrorWrapper>{error && <div className="error">{error.join('<br>')}</div>}</ErrorWrapper>;
};

const ErrorWrapper = styled.div`
  .error {
    color: red;
  }
`;
